import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Project} from '../classes/project';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProjectService {
    constructor(private apiService: ApiService) {
    }

    public getAll() {
        return this.apiService.getCallData$<Project[]>('project/all', null);
    }

    public getVisible(date: Date): Observable<Project[]> {
        return this.apiService.getCallData$<Project[]>('project/visible', {date: date});
    }

    public azure(): Promise<boolean> {
        return this.apiService.getCall<boolean>('project/azure');
    }

    public toggleVisible(project: Project, add: boolean): Promise<boolean> {
        return this.apiService.postCall('project/togglevisible', {
            projectId: project.id,
            add
        });
    }

    public findHiddenProject(searchText: string, date: Date) {
        return this.apiService.getCallData$<Project[]>('project/findhidden', {
            searchText: searchText,
            date: date
        });
    }
}
